import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../shared.functions';
import { AlicuotaIva, SearchAlicuotaIvaRequest } from '../model';

@Injectable({
    providedIn: 'root'
})
export class AlicuotaIvaService extends CrudService<AlicuotaIva, number, any, SearchAlicuotaIvaRequest> {

    constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
        super(_http, 'alicuotaiva', sharedFunctions);
    }
}
